<mat-card>
    <div class="design-and-amount-container">
        <div
            skeletonData
            [showSkeleton]="
                !selectedItemImagePath.value || !isSelectedDesignImageReady
            "
            [placeholderHeight]="'100%'"
            class="selected-image-container"
        >
            <img
                class="mat-card"
                [src]="selectedItemImagePath.value"
                (load)="selectedDesignImageReady()"
            />
        </div>
        <div class="design-and-amount-selection-container">
            <ols-design-selection [designs]="designs"></ols-design-selection>
            <ols-amount-selection
                [suggestedAmounts]="suggestedAmounts"
                [customAmountSettings]="customAmountSettings"
            ></ols-amount-selection>
        </div>
    </div>
</mat-card>
